import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from '../toasts';
import { getError, getUserInfo } from '../utils';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import InputGroup from 'react-bootstrap/InputGroup';
import { Button, Form } from 'react-bootstrap';
import '../App.css';

export default function SignupScreen() {
	const navigate = useNavigate();
	const { search } = useLocation();
	const redirectInUrl = new URLSearchParams(search).get('redirect');
	const redirect = redirectInUrl ? redirectInUrl : '/';

	const [email, setEmail] = useState('');
	const [name, setName] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [passwordType, setPasswordType] = useState('password');
	const [repeatPasswordType, setRepeatPasswordType] = useState('password');

	const togglePassword = () => {
		if (passwordType === 'password') {
			setPasswordType('text');
			return;
		}
		setPasswordType('password');
	};
	const toggleRepeatPassword = () => {
		if (repeatPasswordType === 'password') {
			setRepeatPasswordType('text');
			return;
		}
		setRepeatPasswordType('password');
	};

	const userInfo = getUserInfo();
	const submitHandler = async (e) => {
		e.preventDefault();
		if (password !== confirmPassword) {
			toast.error('Las contraseñas no coinciden');
			return;
		}
		try {
			const { data } = await Axios.post('/api/auth/signup', {
				name,
				email,
				password,
			});
			toast.success(data.message);
			navigate(redirect || '/');
		} catch (err) {
			toast.error(getError(err));
		}
	};

	useEffect(() => {
		if (userInfo) {
			navigate(redirect);
		}
	}, [navigate, redirect, userInfo]);

	return (
		<div className='auth-screen sign-up'>
			<Helmet>
				<title>Registro</title>
			</Helmet>
			<div className='auth-screen__content'>
				<Form className='auth-card auth-card--signup' onSubmit={submitHandler}>
					<h2 className='auth-card__title'>Registro</h2>

					<Form.Group className='auth-field' controlId='signup-name'>
						<Form.Label>Nombre</Form.Label>
						<Form.Control
							className='auth-input'
							type='text'
							placeholder='Nombre completo'
							required
							onChange={(e) => setName(e.target.value)}
						/>
					</Form.Group>

					<Form.Group className='auth-field' controlId='signup-email'>
						<Form.Label>E-mail</Form.Label>
						<Form.Control
							className='auth-input'
							type='email'
							placeholder='nombre@empresa.com'
							required
							onChange={(e) => setEmail(e.target.value.toLowerCase())}
						/>
					</Form.Group>

					<Form.Group className='auth-field' controlId='signup-password'>
						<Form.Label>Contraseña</Form.Label>
						<InputGroup className='auth-password-group'>
							<Form.Control
								className='auth-input'
								type={passwordType}
								placeholder='••••••••'
								required
								onChange={(e) => setPassword(e.target.value)}
							/>
							<Button
								type='button'
								variant='link'
								className='auth-password-toggle'
								aria-label={passwordType === 'password' ? 'Mostrar contraseña' : 'Ocultar contraseña'}
								onClick={togglePassword}
							>
								{passwordType === 'password' ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
							</Button>
						</InputGroup>
					</Form.Group>

					<Form.Group className='auth-field' controlId='signup-confirm-password'>
						<Form.Label>Repetir contraseña</Form.Label>
						<InputGroup className='auth-password-group'>
							<Form.Control
								className='auth-input'
								type={repeatPasswordType}
								placeholder='••••••••'
								required
								onChange={(e) => setConfirmPassword(e.target.value)}
							/>
							<Button
								type='button'
								variant='link'
								className='auth-password-toggle'
								aria-label={repeatPasswordType === 'password' ? 'Mostrar contraseña' : 'Ocultar contraseña'}
								onClick={toggleRepeatPassword}
							>
								{repeatPasswordType === 'password' ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
							</Button>
						</InputGroup>
					</Form.Group>

					<Button className='auth-submit' type='submit'>
						Registrarse
					</Button>

					<p className='auth-card__switch'>
						Ya tienes una cuenta?{' '}
						<Link to={`/signin?redirect=${redirect}`}>
							Inicia sesión
						</Link>
					</p>
				</Form>
			</div>
		</div>
	);
}
